<template>
  <ui-container class="space-y-8 py-8">

    <!-- Header. -->
    <ui-header :title="item.subject"
               :subtitle="`${item.email_type}` + (item.has_attachments ? ` (with attachments)` : ``)"></ui-header>

    <ui-data-grid>
      <ui-data-grid-item label="Sent To" :value="item.recipients()"></ui-data-grid-item>
      <ui-data-grid-item label="CC" :value="item.ccs() ? item.ccs() : 'None' "></ui-data-grid-item>
    </ui-data-grid>

    <hr />

    <div class="prose whitespace-pre-wrap">{{ item.body }}</div>

  </ui-container>
</template>

<script>
export default {
  props: {
    item: Object,

  },
  data() {
    return {}
  },
  methods: {},
}
</script>
